export default "__VITE_ASSET__Y1qC6z9m__"